





























import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import { callAppFunc_getSomeParams, appFunc_callExit } from '@/utils/bridge'
@Component({
  name: 'DownloadAllo',
  components: {}
})
export default class DownloadAllo extends Vue {
  // app版本
  appVersion = ''
  isIos = true

  async created() {
    this.checkisIos()
    await this.getSomeData()
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  async getSomeData() {
    const res = await callAppFunc_getSomeParams()
    CommonModule.setAppVersion(res.versionName)
    this.appVersion = CommonModule.appVersion
  }
  checkisIos() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true
    } else if (/(Android)/i.test(navigator.userAgent)) {
      this.isIos = false
    } else {
      this.isIos = true
    }
  }

  // 立即下载
  handelDownload() {
    if (this.isIos) {
      window.location.href = 'https://itunes.apple.com/app/id1664635935'
    } else {
      window.location.href = process.env.VUE_APP_ALLO
    }
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  //返回
  handelback() {
    appFunc_callExit()
  }
}
